import EcalBackground from '../../../../commons/images/brandImage/ECALWhiteLabel2.jpg';

import EcalLogo from '../../../../commons/images/brandImage/ECAL_Logo.svg';

export default {
    labelName: 'openId',
    favicon: '/favicon.ico?v=3',
    title: 'Admin ECAL',
    background: EcalBackground,
    footerColor: '#010134',
    headerColor: '#010134',
    logo: EcalLogo,
    copyrightText: `© 2010-${new Date().getFullYear()} | ECAL | HyperKu Pte Ltd | All rights reserved.`,
    supportContact: 'support@ecal.com',
    hideIntercomChat: true, /* hide_default_launcher */
    supportLabel: 'ECAL Support',

    signInLabel: 'Sign-in with OpenId',
    signInImage: '',

    provider: 'OpenId',
};
